function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Icon from './icon';
import React from 'react';
var AVAILABLE_CHARS = ['abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '1234567890'].join();
var PASSWORD_MAX_CHARS = 40;

var RandomPasswordGenerator = /*#__PURE__*/function (_React$Component) {
  _inherits(RandomPasswordGenerator, _React$Component);

  var _super = _createSuper(RandomPasswordGenerator);

  function RandomPasswordGenerator(props) {
    var _this;

    _classCallCheck(this, RandomPasswordGenerator);

    _this = _super.call(this, props);
    _this.state = {
      generatedPassword: '',
      isPasswordVisible: false
    };
    return _this;
  }

  _createClass(RandomPasswordGenerator, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          passwordText = _this$props.passwordText,
          randomPasswordText = _this$props.randomPasswordText,
          readonly = _this$props.readonly,
          tip = _this$props.tip;
      var _this$state = this.state,
          generatedPassword = _this$state.generatedPassword,
          isPasswordVisible = _this$state.isPasswordVisible;
      var feedbackIcon = isPasswordVisible ? 'eye-open' : 'eye-close';
      var inputType = isPasswordVisible ? 'text' : 'password';
      return React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", {
        className: "col-lg-12 col-xl-10 col-xl-offset-1",
        htmlFor: "merchant_".concat(name)
      }, passwordText), React.createElement("div", {
        className: "col-lg-12 col-xl-10 col-xl-offset-1"
      }, tip && React.createElement("div", {
        className: "alert alert-info-light alert-slim"
      }, tip), React.createElement("div", {
        className: "input-group"
      }, React.createElement("input", {
        className: "form-control",
        type: inputType,
        id: "merchant_".concat(name),
        name: "merchant[".concat(name, "]"),
        value: generatedPassword,
        readOnly: readonly,
        onChange: function onChange(event) {
          return _this2.handleChange(event);
        }
      }), React.createElement(Icon, {
        handleClick: function handleClick() {
          return _this2.togglePasswordVisibility();
        },
        icon: feedbackIcon,
        className: "form-control-feedback generated-password-feedback-icon"
      }), React.createElement("div", {
        className: "input-group-btn"
      }, React.createElement("a", {
        onClick: function onClick() {
          _this2.setNewPassword();
        },
        className: "btn btn-primary btn-block",
        id: "random_pass_for_merchant",
        remote: "remote"
      }, randomPasswordText)))));
    }
  }, {
    key: "generatePassword",
    value: function generatePassword() {
      var maxCharsLen = this.props.maxCharsLen;
      var pass = '';

      for (var x = 0; x < maxCharsLen; x += 1) {
        var i = Math.floor(Math.random() * AVAILABLE_CHARS.length);
        pass += AVAILABLE_CHARS.charAt(i);
      }

      return pass;
    }
  }, {
    key: "setNewPassword",
    value: function setNewPassword() {
      this.setState({
        generatedPassword: this.generatePassword()
      });
    }
  }, {
    key: "togglePasswordVisibility",
    value: function togglePasswordVisibility() {
      this.setState(function (state) {
        return {
          isPasswordVisible: !state.isPasswordVisible
        };
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        generatedPassword: event.target.value
      });
    }
  }]);

  return RandomPasswordGenerator;
}(React.Component);

RandomPasswordGenerator.defaultProps = {
  maxCharsLen: PASSWORD_MAX_CHARS,
  name: 'pwd_clear',
  readonly: true
};
export default RandomPasswordGenerator;